import * as z from "zod";

export const getTelnyxTelephonyToken = {
  name: "getTelnyxTelephonyToken" as const,
  input: z.object({}),
  output: z.object({ token: z.string() }),
};
